import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import {
  requestOtp,
  resetAPIParams,
} from "../../../../store/slices/requestOTPSlice";
import { Container, FullWidthButton } from "./footer.styles";
import LoadingSVG from "@shared/loadingSVG";
import { setGenericInformation } from "store/slices/genericInformation";
import { amazonSignOut } from "utils/auth";
import { KYCConstants } from "constants/application";
import { ROUTES_VARIANT } from "constants/routesVariant";

function Footer() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const otp = useSelector((state: any) => state.otp);
  const info = useSelector((state: any) => state.info.allData);

  // Take the phone number and customerId value from URL search params
  // if they don't exists disable the "Request OTP" button and show the error info
  // search param "mob" container 10 digit mobile number comes from brp application don't change this, unless needed
  // search param "ccode" container customerId comes from brp application don't change this, unless needed

  const queryParams = new URLSearchParams(location.search);
  const mob = queryParams.get("mob");
  const ccode = queryParams.get("ccode");

  useEffect(() => {
    // Clear the existing session and start new one
    amazonSignOut();
    // Store phone number and customerId in store
    dispatch(
      setGenericInformation({
        ...info,
        mobileNumber: mob || "",
        customerId: String(ccode).toLocaleUpperCase(),
      })
    );
  }, [mob, ccode]);

  useEffect(() => {
    if (otp.success) {
      dispatch(resetAPIParams() as any);
      navigate(`/${ROUTES_VARIANT.VERIFY_OTP}`, { replace: true });
    }
  }, [otp.success]);

  const fetchOtp = () => {
    if (mob) dispatch(requestOtp({phoneNumber: mob,customerId: ccode }) as any);
  };

  return (
    <Container>
      {!mob && (
        <Alert severity="error" sx={{ color: "#333" }}>
          {t("phone_number_unavailable", {
            defaultValue: "Phone Number Unavailable",
          })}
        </Alert>
      )}
      {!otp.isUserRegistered && (
        <Alert severity="error" sx={{ color: "#333" }}>
          {t("phone_number_not_registered", {
            defaultValue: "Phone Number not Registered",
          })}
        </Alert>
      )}
      {/* <Typography sx={{ pt: 1 }} variant="body2" color="#666666">
        <Trans
          i18nKey={"terms_and_condition_text"}
          components={{
            mark: (
              <Typography
                component={"span"}
                variant="body2"
                fontWeight={600}
                color="primary"
              />
            ),
          }}
        />
      </Typography> */}
      <FullWidthButton
        disabled={!mob}
        variant="contained"
        size="large"
        fullWidth
        loading={otp.loading}
        loadingIndicator={<LoadingSVG />}
        onClick={fetchOtp}
      >
        {t("request_otp", { defaultValue: "Request OTP" })}
      </FullWidthButton>
      <Snackbar
        open={otp?.error}
        onClose={() => dispatch(resetAPIParams() as any)}
        autoHideDuration={KYCConstants.autoHideDuration}
        message={otp?.error}
        sx={{ bottom: { xs: 90, sm: 0 } }}
      />
    </Container>
  );
}

export default Footer;
